import './assets/main.css';

import { createApp } from 'vue';

import App from './App.vue';
import setupIcons from './assets/setupIcons';

import setupPrimevue from './assets/setupPrimevue';
import router from './router/app.router';
import { initTheme } from './pds/composables/useTheme';
import { pinia } from './stores';
import { ToastService } from 'primevue';

initTheme();

const app = createApp(App);

app.use(pinia).use(router).use(ToastService);

setupIcons(app);
setupPrimevue(app);

app.mount('#app');
